import type { NodePropertySchema } from '../../../types/node-properties';

const schema: NodePropertySchema = {
  nodeType: 'text-to-binary',
  version: '1.0.0',
  properties: [
    {
      key: 'textPropertyName',
      label: 'Source Data',
      type: 'string',
      default: '',
      placeholder: '{{ $node["Previous Node"].output }}',
      description:
        'Expression to get source data (e.g., {{ $node["HTTP Request"].output }}). Leave empty to auto-detect from previous node. Objects/arrays will be serialized to JSON.',
      supportsExpressions: true,
    },
    {
      key: 'mimeType',
      label: 'MIME Type',
      type: 'options',
      default: 'application/json',
      description: 'The MIME type for the output binary data',
      options: [
        { value: 'application/json', label: 'JSON (application/json)' },
        { value: 'text/plain', label: 'Plain Text (text/plain)' },
        { value: 'text/html', label: 'HTML (text/html)' },
        { value: 'text/css', label: 'CSS (text/css)' },
        { value: 'text/javascript', label: 'JavaScript (text/javascript)' },
        { value: 'text/csv', label: 'CSV (text/csv)' },
        { value: 'text/xml', label: 'XML (text/xml)' },
        { value: 'application/xml', label: 'XML (application/xml)' },
        { value: 'application/octet-stream', label: 'Binary (application/octet-stream)' },
      ],
    },
    {
      key: 'fileName',
      label: 'File Name',
      type: 'string',
      default: 'output.json',
      placeholder: 'output.json',
      description: 'The filename for the output binary data',
      supportsExpressions: true,
    },
    {
      key: 'encoding',
      label: 'Encoding',
      type: 'options',
      default: 'utf-8',
      description: 'Character encoding to use when converting text to binary',
      options: [
        { value: 'utf-8', label: 'UTF-8 (Recommended)' },
        { value: 'utf-16', label: 'UTF-16 (Little Endian)' },
        { value: 'utf-16be', label: 'UTF-16 (Big Endian)' },
        { value: 'utf-32', label: 'UTF-32' },
        { value: 'ascii', label: 'ASCII' },
        { value: 'iso-8859-1', label: 'ISO-8859-1 (Latin-1)' },
        { value: 'windows-1252', label: 'Windows-1252' },
      ],
    },
    {
      key: 'addBom',
      label: 'Add BOM',
      type: 'boolean',
      default: false,
      description: 'Add Byte Order Mark (BOM) at the start of the binary data',
    },
    {
      key: 'binaryPropertyName',
      label: 'Binary Property Name',
      type: 'string',
      default: 'data',
      placeholder: 'data',
      description: 'The property name for the output binary data',
    },
  ],
};

export default schema;
